import { create } from 'zustand';

export interface PaymentMethodStoreState {
  cashSelected: boolean;
  checkNumber: string;
  manualCheckSelected: boolean;
  reset: () => void;
  selectCash: () => void;
  selectManualCheck: () => void;
  setCheckNumber: (checkNumber: string) => void;
}

/**
 * Tracks the payment method selected for the active payment.
 *
 * Today it only covers the manual "record payment" methods (cash / manual
 * check) and the entered check number, but it's intentionally generic so it can
 * grow to hold the rest of the payment-method selection over time.
 */
export const usePaymentMethodStore = create<PaymentMethodStoreState>((set) => ({
  cashSelected: false,
  checkNumber: '',
  manualCheckSelected: false,
  reset: () =>
    set({ cashSelected: false, checkNumber: '', manualCheckSelected: false }),
  selectCash: () =>
    set({ cashSelected: true, checkNumber: '', manualCheckSelected: false }),
  selectManualCheck: () =>
    set({ cashSelected: false, checkNumber: '', manualCheckSelected: true }),
  setCheckNumber: (checkNumber) => set({ checkNumber }),
}));
